import { Component, OnInit, OnDestroy, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { NavigationStart, NavigationEnd, Router, ActivatedRoute, RouterModule } from '@angular/router';
import * as globalConstant from '../../global_constant';
import { SettingsService } from '../../services/Settings.service';
import { EncryptionService } from '../../services/encryption.service';

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'src/app/services/toastr.service';
import { MainService } from 'src/app/main.service';
import { AddExperience } from 'src/app/services/AddExperience.service';
import { Subscription } from 'rxjs';


@Component({
	selector: 'vebo-footer',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		RouterModule
	],
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy, AfterViewInit {

	copy_right: any;
	isBrowser: boolean;
	settings_data: any;
	login: any = '';
	currentYear: any = '';
	captchaData: any;
	facebookSocialLink = globalConstant.FACEBOOK_SOCIAL_LINK
	linkedinSocialLink = globalConstant.LINKEDIN_SOCIAL_LINK
	pinterestSocialLink = globalConstant.PINTEREST_SOCIAL_LINK
	instagramSocialLink = globalConstant.INSTAGRAM_SOCIAL_LINK
	tiktokSocialLink = globalConstant.TIKTOK_SOCIAL_LINK
	androidAppDownloadLink = globalConstant.ANDROID_APP_DOWNLOAD_LINK
	iphoneAppDownloadLink = globalConstant.IOS_APP_DOWNLOAD_LINK;
	SubscribeForm: FormGroup;
	static EMAIL: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	submitted = false;
	subscribe_error_message: any = '';
	subscribe_error = false;
	web_cdn_url: String = globalConstant?.WEB_CDN_URL;
	contactNumber: any;
	contactEmail: any;
	sitemapUrl = 'https://spurexperiences.com/sitemap.xml';
	// contactNumber: any = '(720) 577-3141';
	// contactEmail: any = 'info@spurexperiences.com';

	locationList: any[] = [];
	categoryList: any[] = [];
	giftIdeasList: any[] = [];
	openNavSection: string | null = null;

	private subscriptions = new Subscription();


	constructor(
		private settingService: SettingsService,
		private encryptionService: EncryptionService,
		private formBuilder: FormBuilder,
		public toastr: ToastrService,
		private addexperience: AddExperience,
		private mainService: MainService,
		public router: Router,
		@Inject(PLATFORM_ID) platformId: Object
	) {
		this.currentYear = new Date().getFullYear()
		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {
			if (typeof window !== 'undefined') {
				window.scrollTo(0, 0);
			}
		}
		this.subscriptions.add(
			this.router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					if (this.isBrowser) {
						if (typeof localStorage !== 'undefined') {
							if (localStorage.getItem('authUser')) {
								this.login = true;
							} else {
								this.login = false;
							}
						}
					}
				}
			})
		);
	}

	ngOnInit() {
		if (this.isBrowser) {
			this.settingService.get_config().subscribe(res => {
				if (res.response == "success" && res?.data) {
					// Store encrypted config; decrypt when reading via EncryptionService.getCaptchaSettings()
					localStorage.setItem('captchaSetting', res.data);
					try {
						const configData = this.encryptionService.decryptPayload(res.data);
						let data = configData?.data || [];
						this.settings_data = configData;
						this.captchaData = configData;

						if (data) {
							const contactNumberSetting = data.find((setting: any) => setting.key === 'Site.contact_number');
							const contactEmailSetting = data.find((setting: any) => setting.key === 'Site.contact_email');
							this.contactNumber = contactNumberSetting?.value || '';
							this.contactEmail = contactEmailSetting?.value || '';
						} else {
							this.contactNumber = '(720) 577-3141';
							this.contactEmail = 'info@spurexperiences.com';
						}
						this.loadConfiguredChatbot(configData);
					} catch (e) {
						console.error('Failed to decrypt config data:', e);
						this.settings_data = true;
					}
				}
			});
		}

		this.subscriptions.add(
			this.addexperience.locationMenuList$.subscribe((res: any) => {
				this.locationList = res?.data || [];
			})
		);

		this.subscriptions.add(
			this.mainService.categoriesMenuList$.subscribe((res: any) => {
				this.categoryList = res?.data || [];
			})
		);

		this.subscriptions.add(
			this.mainService.giftIdeasMenuList$.subscribe((res: any) => {
				this.giftIdeasList = res?.data || [];
			})
		);

		this.SubscribeForm = this.formBuilder.group({
			email: ['', [Validators.required, Validators.email, Validators.pattern(FooterComponent.EMAIL)]],
		});

	}

	get subscribeFormCtrl() {
		return this.SubscribeForm.controls;
	}

	toggleNavSection(section: string) {
		this.openNavSection = this.openNavSection === section ? null : section;
	}

	isNavOpen(section: string): boolean {
		return this.openNavSection === section;
	}

	onSubscribeSubmit() {
		this.submitted = true;
		this.subscribe_error = false;
		this.subscribe_error_message = '';

		// stop here if form is invalid
		if (this.SubscribeForm.invalid) {
			this.toastr.errorToastr("Enter a valid Email.", "Error")
			return;
		} else {

			let reuestBody = { 'email': this.SubscribeForm.get('email').value.replace(/^\s+|\s+$/gm, '') };
			this.mainService.subscribeUser(reuestBody).subscribe(res => {
				if (res?.response == "success") {
					this.SubscribeForm.controls['email'].setValue('');
					this.toastr.successToastr(res?.message, "Success")
					this.submitted = false;
				} else {
					this.subscribe_error = true;
					this.subscribe_error_message = res?.message;

				}
			});
		}
	}

	private loadConfiguredChatbot(configData: any) {
		const win = window as any;
		if (win.__spurChatbotLoaded) {
			return;
		}
		win.__spurChatbotLoaded = true;

		const chatbotMode = configData?.extra_settings?.chatbot_mode;
		if (Number(chatbotMode) === 0) {
			win.loadGotoChatbot?.();
			return;
		}
		win.loadAanyaChatbot?.();
	}

	ngAfterViewInit() {
		if (this.isBrowser) {
			var msgProp = document.getElementById("msgIocnFixed")
			if (msgProp != null && msgProp != undefined) {
				msgProp.classList.add('open');
			}
		}

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
